import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'manage-cohorts',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./ManageCohorts').default
      callback(null, component)
    }, 'ManageCohorts')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/ManageCohorts/index.js